import { types } from 'mobx-state-tree';

export const EducationQualifications = types.model('EducationQualificationsModel', {
  name: types.maybe(types.string),
  schoolOrInstitute: types.maybe(types.string),
  yearOfCompletion: types.maybeNull(types.string),
  gradings: types.maybe(types.string),
});
